var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgBalanceOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9205 0.125L29.091 5.2955L28.8604 5.52612L27.0276 7.35885L23.9205 10.466L22.3295 8.875L24.3117 6.8928L24.784 6.4205H13.75V4.1705H24.784L22.3295 1.71599L23.9205 0.125ZM15 13.0705C14.1163 13.0705 13.4 13.7868 13.4 14.6705C13.4 15.5541 14.1163 16.2705 15 16.2705C15.8837 16.2705 16.6 15.5541 16.6 14.6705C16.6 13.7868 15.8837 13.0705 15 13.0705ZM11.6 14.6705C11.6 12.7927 13.1222 11.2705 15 11.2705C16.8778 11.2705 18.4 12.7927 18.4 14.6705C18.4 16.5482 16.8778 18.0705 15 18.0705C13.1222 18.0705 11.6 16.5482 11.6 14.6705ZM7.5 14.6705C7.5 15.3608 6.94036 15.9205 6.25 15.9205C5.55964 15.9205 5 15.3608 5 14.6705C5 13.9801 5.55964 13.4205 6.25 13.4205C6.94036 13.4205 7.5 13.9801 7.5 14.6705ZM2.25 6.62185C4.37627 7.15059 7.7866 7.67397 11.5 6.9658V8.67048H13.9848C10.4073 9.74977 6.9837 9.68287 4.37797 9.32096C3.59794 9.21263 2.88333 9.07682 2.25 8.93403V19.4913L2.26046 19.4957C3.05702 19.8358 4.18687 20.2661 5.50892 20.6234C8.21184 21.3539 11.4271 21.7006 14.2311 20.6809C17.9614 19.3245 21.9577 18.8359 24.9567 18.6738C26.0142 18.6166 26.9623 18.5993 27.75 18.6012V9.81847L30 7.56847V20.9205C30 20.9205 29.1429 20.8546 27.75 20.8512C24.8541 20.8441 19.6421 21.1074 15 22.7955C8.125 25.2955 0 20.9205 0 20.9205V5.92048C0 5.92048 0.844452 6.27233 2.25 6.62185ZM23.75 15.9205C24.4404 15.9205 25 15.3608 25 14.6705C25 13.9801 24.4404 13.4205 23.75 13.4205C23.0596 13.4205 22.5 13.9801 22.5 14.6705C22.5 15.3608 23.0596 15.9205 23.75 15.9205Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceOutlined);
export default __webpack_public_path__ + "static/media/balanceOutlined.dfc3d23ff07a0ff70cb002ed08586490.svg";
export { ForwardRef as ReactComponent };